import './Header.css'

export default function Header() {
    return(
        <div className="Header"><h1>The Melting Pot Restaurant</h1></div>
    )
}